import { render, staticRenderFns } from "./ItemOpenMethodIcon.vue?vue&type=template&id=bd61f3bc&scoped=true&"
import script from "./ItemOpenMethodIcon.vue?vue&type=script&lang=js&"
export * from "./ItemOpenMethodIcon.vue?vue&type=script&lang=js&"
import style0 from "./ItemOpenMethodIcon.vue?vue&type=style&index=0&id=bd61f3bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd61f3bc",
  null
  
)

export default component.exports